import { memo } from "react";
import { DialogContent } from "@mui/material";

import PasswordRecoveryForm from "components/auth/PasswordRecoveryForm";
import ClosableDialog from "components/shared/ClosableDialog";
import useDialog from "hooks/useDialog";

const LoginDialog: React.FC = () => {
  const { openPasswordRecoveryDialog, setOpenPasswordRecoveryDialog } =
    useDialog();

  return (
    <ClosableDialog
      open={openPasswordRecoveryDialog}
      onClose={() => setOpenPasswordRecoveryDialog(false)}
    >
      <DialogContent>
        <PasswordRecoveryForm />
      </DialogContent>
    </ClosableDialog>
  );
};

export default memo(LoginDialog);
